const isString = (it)=>'string' == typeof it;
export { isString };

//# sourceMappingURL=isString.mjs.map